import './Switch.scss'
import PrivateUserIcon from '../icons/privateUser';
import BusinessUserIcon from '../icons/businessUser';

export function Switch (props: {version?:string}) {
    return <div className="gno-switch">
        {props.version === "private" ? 
        <div className="gno-switch-container">
            <SwitchButton icon= {<PrivateUserIcon />} state="gno-button-active" route = {() => window.open('/startseite', "_self")}/>
            <SwitchButton icon= {<BusinessUserIcon />} state="gno-button-passive" route = {() => window.open('/unternehmen', "_self")}/>
        </div> 
        :
        <div className="gno-switch-container">
            <SwitchButton icon= {<PrivateUserIcon />} state="gno-button-passive" route = {() => window.open('/startseite', "_self")}/>
            <SwitchButton icon= {<BusinessUserIcon />} state="gno-button-active" route = {() => window.open('/unternehmen', "_self")}/>
        </div> 
        }
    </div>
}

function SwitchButton (props: {icon?: any, state: string, route: Function}) {
    
    return <div className={`gno-switch-button ${props.state}`} onClick={() => props.route()}>
        {props.icon}
    </div>
}

export function Status (props: {page: string, lable: string}) {
    return <div className="gno-status">
        <div className="gno-status-container">
            <div className="gno-status-text breadcrumb-item">
                <p className="breadcrumb-item">{props.page}</p>
                <p className="breadcrumb-item"></p> 
                <p className ="gno-text-purple breadcrum-item">{props.lable}</p>
            </div>
        </div>
    </div>
}